import { render, staticRenderFns } from "./me.vue?vue&type=template&id=6b8caf98&scoped=true&"
import script from "./me.vue?vue&type=script&lang=ts&"
export * from "./me.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8caf98",
  null
  
)

export default component.exports